import { frontendURL } from '../../../../helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions.js';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const WhatsappTemplatesHome = () => import('./Index.vue');
const ModeloEditor = () => import('./ModeloEditor.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/whatsapp-templates'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'whatsapp_templates_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'whatsapp_templates_list',
          meta: {
            permissions: [...ROLES],
          },
          component: WhatsappTemplatesHome,
        },
        // Página inteira para escrever o modelo, como no portal da WAME
        // (25/09/2026); a caixa vem em ?caixa=.
        // Os caminhos INTERNOS são em inglês como os vizinhos (06/10/2026): a
        // barra traduz cada palavra (`new` → `novo`), e um "novo" interno
        // colidia com a tradução. Os antigos redirecionam.
        { path: 'novo', redirect: { name: 'whatsapp_templates_novo' } },
        {
          path: ':templateId/editar',
          redirect: to => ({
            name: 'whatsapp_templates_editar',
            params: to.params,
            query: to.query,
          }),
        },
        {
          path: 'new',
          name: 'whatsapp_templates_novo',
          meta: {
            permissions: ['administrator'],
          },
          component: ModeloEditor,
        },
        {
          path: ':templateId/edit',
          name: 'whatsapp_templates_editar',
          meta: {
            permissions: ['administrator'],
          },
          component: ModeloEditor,
        },
      ],
    },
  ],
};
